export default __webpack_public_path__ + "static/media/telegram.4f8cfb98.svg";